var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('CardView',[_c('div',{staticClass:"container-fluid"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col"},[_c('FormTaskDefinition',{on:{"update":_vm.create}})],1),_c('div',{staticClass:"col"},[_c('subtask-list',{attrs:{"subtasks":_vm.subtasks}})],1)])])])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }